<script setup lang="ts">
import {onMounted, ref} from "vue";
import {metricsApi} from "@/container";
import {VisitMetrics} from "@/core/http/resources/MetricsResource";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import PatientVisitTable from "@/patient-administration/components/PatientVisitTable.vue";

const metrics = ref<{
    local: VisitMetrics[];
    global: VisitMetrics[];
}>();

const loading = ref<boolean>(true);

onMounted(async () => {
    metrics.value = await metricsApi().visits();
    loading.value = false;
});


</script>

<template>
  <div class="p-6 space-y-6 pb-24">
    <BaseFlexSpinner v-if="loading" class="pt-14" />
    <div v-else class="flex flex-col gap-4">
      <h1>Statistiques de fréquentation</h1>
      <div class="flex gap-4">
        <BaseCard class="flex-1 p-4">
          <h2>Votre pharmacie <span class="text-sm text-black">/ Statistiques nationales</span></h2>
          <PatientVisitTable :metrics="metrics!" />
        </BaseCard>
      </div>
    </div>
  </div>
</template>
